<template>
  <w-modal
    v-dialogDrag
    :visible.sync="dialogVisible"
    width="80%"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    :before-close="dialogClose"
  >
    <div slot="title" class="title-container">
      <img class="logo" src="@/common/assets/images/login-logo.svg" />
      <div class="text">查看打分细节</div>
    </div>
    <div class="modal-window-text">
        <h3><span>检查项目：</span> <span>{{ tableData[0].BZMC }}</span></h3>
        <w-table
          ref="inspectTable"
          :data="tableData"
          highlight-current-row
          style="width: 100%"
          border
        >
          <w-table-column prop="JCZMC" label="检查者" align="center" width="130"></w-table-column>
          <w-table-column
           v-if="showField.TSHCB === '0' && showField.isHGL !== '1'" 
           :label="showField.JCFS !== 1024 ? '扣加分' : '结果'" 
           align="center" 
           width="210"
          >
          <template slot-scope="scope"> 
              <w-input
               v-if="showField.JCFS === 1022"
                 v-model="scope.row.KFJG"
                readonly
                size="small"
                 style="min-width: 100%"
            ></w-input>
        <w-radio-group v-else v-model="scope.row.KFJG">
          <w-radio
            v-for="ck in showField.checkResultList"
            :key="ck.JGDM"
            style="display: block; text-align: left; margin: 5px 0px"
            disabled
            size="small"
            :class="ck.JGDM ? 'red-item' : ''"
            :label="ck.JGDM"
            >{{ ck.JGMC }}</w-radio
          >
          </w-radio-group>
            </template>
           </w-table-column>
          <!-- 核查表 -->
          <w-table-column 
            v-if="showField.TSHCB === '1' || showField.isHGL === '1'"
            label="结果&样本&占比情况" 
            width="230" 
          >
          <template slot-scope="scope">
            <div v-for="list in scope.row.HCBJGList" :key="list.JGDM" class="flex">
              <span class="w50">{{ list.JGMC }}</span>
              <w-input v-model.number="list.YBSL" class="w30" readonly></w-input>
                <span class="w20">{{
                  Number((list.YBZB * 100).toFixed(2)) + '%'}}
                </span>
             </div>
          </template>
         </w-table-column>
          <w-table-column  label="未涉及" width="80" align="center">
              <template slot-scope="scope">
                 <w-checkbox
                    v-model="scope.row.SFWSJ"
                    disabled
                  ></w-checkbox>
              </template>
          </w-table-column>
          <w-table-column
             v-if="showField.TSHCB === '1' || showField.isHGL === '1'"
            label="合格率"
            width="90"
          >
            <template slot-scope="scope">
               <span>{{ Number((scope.row.HGL * 100).toFixed(2)) + '%' }}</span>
            </template>
          </w-table-column>
          <w-table-column prop="KFYYSM" label="扣分原因说明" ></w-table-column>
          <w-table-column 
            v-if="showField.JCLX !== 1020"
            prop="BCHSMC"
            label="被查护士" 
            align="center" 
            width="120"
          ></w-table-column>
          <w-table-column 
            prop="ZRRDMC" 
            label="责任人" 
            align="center" 
            width="120"
          ></w-table-column>
          <w-table-column 
             v-if="showField.JCLX === 1020 || (showField.JCLX === 1019 && showField.Mjdm === '1')"
            prop="BCBRMC" 
            label="被查患者" 
            width="120"
          ></w-table-column>
          <!-- <w-table-column label="附件" align="center" width="100">
              <template slot-scope="scope">
                  {{ scope.row.TPSL ? scope.row.TPSL : '--' }}
              </template>
          </w-table-column> -->
        </w-table>          
    </div>
    <div class="modal-window-footer">
      <div class="window-footer-btns">
        <w-button type="primary" @click="closePage()">关闭</w-button>
      </div>
    </div>
  </w-modal>
</template>

<script>

export default {
  name: 'MoreDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogClose: {
      type: Function,
      default: () => {}
    },
    conflictData:{
      type: Function,
      default: () => {}
    },
    row: {
      type: Array,
      default: []
    },
    showField:{
      type: Object,
      default:()=>{
        return {}
      }
    }
  },
  data() {
    return {
      tableData: [],
    }
  },
  computed: {},
  watch: {
  },
  created() {
    this.tableData = this.row
    this.tableData.forEach(item => {
       item.SFWSJ = (item.SFWSJ == '0' || item.SFWSJ == null) ? false : true 
       item.KFJG = item.KFJG === null ?  item.KFJG : parseFloat(item.KFJG)
       // 设置默认合格率
       if(item.HCBJGList.length > 0){
        let judgeObj = item.HCBJGList.find(items => items.YBSL != 0)
        if(!judgeObj){
          item.HGL = 1
        }
       }
    });
  },
  mounted(){
  },
  methods: {
    closePage(){ //关闭页面
      this.dialogClose()
    },
    resultFj(data){
     return  (data === '' || data===null) ? '--' : data
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-window-text{
   h3{
      margin: 0px;
      font-size: 14px;
      margin-bottom: 10px;
   }
}

/deep/ .w-modal__header{
  padding: 0px;
}
.title-container {
display: flex;
font-weight: 700;
background-color:rgba(	81, 117, 244,.5);
height: 40px;
line-height: 40px;
.logo {
  width: 28px;
  height: 28px;
  margin: 4px 10px 0px 12px;
}
.text {
  height: 40px;
  line-height: 40px;
  font-size: 15px;
}
}
/deep/ .el-dialog__headerbtn{
  top: 0px;
  height: 40px;
  right: 0px;
  font-size: 22px;
  padding: 0px 16px;
  &:hover{
    background-color: red;
  }
  .el-dialog__close{
    color:#666;
    font-weight: 700;
  }
}
/deep/ .w-table--fit{
  width: 100%;
  height: 43vh;
  overflow-y: auto;
  margin-bottom: 50px;
  border: none;;
  &::before{
      height: 0px;
  }
}
/deep/ .el-dialog__header{
padding: 0px;
}

/deep/ .w-table--border{
  &::after{
      height: 0px;
  }
}
/deep/ .w-table__body-wrapper{
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
}
.w30 {
width: 50%;
margin: 0 12px;
}
.w20{
  width: 28%;
  text-align: right;
}
.w50{
  width: 38%;
  text-align: left;
}
</style>